import type { UseQueryOptions } from "@tanstack/react-query";

import { useApiQuery } from "@/hooks/api/use-api-query";
import type { ApiError } from "@/lib/api-client";

type TenantCdrSummaryResponse = {
  daily: Array<{
    date: string;
    count: number;
  }>;
};

export function useTenantCdrSummaryQuery(
  tenantId: string | undefined,
  windowDays = 7,
  options?: Omit<
    UseQueryOptions<TenantCdrSummaryResponse, ApiError>,
    "queryKey" | "queryFn"
  >
) {
  return useApiQuery<TenantCdrSummaryResponse, ApiError>({
    queryKey: ["tenant-cdr-summary", tenantId, windowDays],
    path: tenantId ? `/api/organizations/${tenantId}/cdrs/summary` : "",
    request: {
      params: {
        windowDays: windowDays.toString(),
      },
    },
    queryOptions: {
      enabled: Boolean(tenantId) && (options?.enabled ?? true),
      ...options,
    },
  });
}
